import { IconButton, List, ListItem, ListItemIcon, makeStyles, Popover, Typography } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import MoreIcon from '@material-ui/icons/MoreVert';
import React, { useCallback, useContext, useState } from 'react';

import { HSTableContext } from 'Common/Table/HSTable/hs-table.context';
import Toolbar from 'Common/Toolbar';

import { CaseTeamsContext } from '../../case-teams.context';
import CaseTeamsForm from '../Form';

const useStyles = makeStyles(theme => ({
  grow: {
    flexGrow: 1,
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
}));

export default function ToolbarCaseTeams() {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState<HTMLElement>(null);
  const openPopover = useCallback(({ target }) => setAnchorEl(target as HTMLElement), []);
  const closePopover = useCallback(() => setAnchorEl(null), []);
  const { setNewDialogOpened, newDialogOpened, setSelectedData, emergencyManagementCaseTeams, reload } = useContext(CaseTeamsContext);

  const closeDialog = useCallback(
    async (success: boolean) => {
      if (success) {
        await reload();
      }
      setNewDialogOpened(false);
      setSelectedData(null);
    },
    [setNewDialogOpened, setSelectedData, reload]
  );

  const newPpeDefinition = useCallback(() => {
    closePopover();
    setNewDialogOpened(true);
  }, [setNewDialogOpened, closePopover]);

  return (
    <Toolbar color="secondary">
      <Typography variant="h6" color="inherit">
        Acil Ekip Üyesi ({emergencyManagementCaseTeams?.length})
      </Typography>
      <span className={classes.grow} />
      <div className={classes.sectionDesktop}>
        <IconButton color="inherit" onClick={openPopover}>
          <MoreIcon />
        </IconButton>
        <Popover anchorEl={anchorEl} anchorOrigin={{ vertical: 35, horizontal: -175 }} keepMounted open={!!anchorEl} onClose={closePopover}>
          <List>
            <ListItem onClick={newPpeDefinition} className="cursor-pointer">
              <ListItemIcon>
                <AddIcon fontSize="small" />
              </ListItemIcon>
              <Typography variant="inherit">Yeni Acil Ekip Üyesi</Typography>
            </ListItem>
          </List>
        </Popover>
      </div>
      <CaseTeamsForm open={newDialogOpened} onClose={closeDialog} data={null} />
    </Toolbar>
  );
}
